import React from 'react'
import { formatTemplateName } from '../whatsapp/waTemplateUtils'

const WA = '#25D366'
const WA_DARK = '#128C7E'

// Created By Cursor — confirm before queueing WhatsApp messages
export default function CommSendConfirmDialog({
  title = 'Send messages?',
  subtitle = '',
  recipientCount = 0,
  templateName = '',
  preview = '',
  confirmLabel = 'Send',
  busy = false,
  onConfirm,
  onClose,
}) {
  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(15, 23, 42, 0.52)',
        backdropFilter: 'blur(4px)',
        zIndex: 1060,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 20,
      }}
      onClick={busy ? undefined : onClose}
    >
      <div
        style={{
          background: '#fff',
          borderRadius: 16,
          width: '100%',
          maxWidth: 480,
          maxHeight: '86vh',
          display: 'flex',
          flexDirection: 'column',
          boxShadow: '0 24px 48px rgba(15, 23, 42, 0.22)',
          overflow: 'hidden',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          style={{
            padding: '16px 18px',
            background: `linear-gradient(120deg, ${WA_DARK} 0%, ${WA} 100%)`,
            color: '#fff',
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            gap: 12,
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, minWidth: 0 }}>
            <span
              style={{
                width: 40,
                height: 40,
                borderRadius: 11,
                background: 'rgba(255,255,255,0.2)',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
              }}
            >
              <i className="fa fa-whatsapp" style={{ fontSize: 20 }} aria-hidden />
            </span>
            <div style={{ minWidth: 0 }}>
              <div style={{ fontWeight: 800, fontSize: 17, lineHeight: 1.25 }}>
                {title}
              </div>
              {subtitle ? (
                <div style={{ fontSize: 12, opacity: 0.92, fontWeight: 600, marginTop: 3 }}>
                  {subtitle}
                </div>
              ) : null}
            </div>
          </div>
          <button
            type="button"
            onClick={onClose}
            disabled={busy}
            aria-label="Close"
            style={{
              border: '1px solid rgba(255,255,255,0.35)',
              background: 'rgba(255,255,255,0.12)',
              color: '#fff',
              width: 34,
              height: 34,
              borderRadius: 8,
              fontWeight: 800,
              fontSize: 18,
              lineHeight: 1,
              cursor: busy ? 'not-allowed' : 'pointer',
              flexShrink: 0,
            }}
          >
            ×
          </button>
        </div>

        <div style={{ padding: '16px 18px', overflow: 'auto', flex: 1 }}>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: preview ? 14 : 0 }}>
            <InfoChip
              icon="fa-users"
              label={`${recipientCount} recipient${recipientCount === 1 ? '' : 's'}`}
            />
            {templateName ? (
              <InfoChip
                icon="fa-file-text-o"
                label={formatTemplateName(templateName)}
              />
            ) : null}
          </div>

          {preview ? (
            <div>
              <div
                style={{
                  fontSize: 11,
                  fontWeight: 800,
                  letterSpacing: '0.04em',
                  textTransform: 'uppercase',
                  color: '#64748b',
                  marginBottom: 6,
                }}
              >
                Sample message
              </div>
              <div
                style={{
                  background: '#f0fdf4',
                  border: `1px solid ${WA}55`,
                  borderRadius: 12,
                  padding: '12px 14px',
                  fontSize: 14,
                  fontWeight: 600,
                  color: '#0f172a',
                  lineHeight: 1.55,
                  whiteSpace: 'pre-wrap',
                  wordBreak: 'break-word',
                }}
              >
                {preview}
              </div>
              {recipientCount > 1 ? (
                <div
                  style={{
                    marginTop: 8,
                    fontSize: 12,
                    color: '#64748b',
                    fontWeight: 600,
                  }}
                >
                  Each recipient gets their own filled values.
                </div>
              ) : null}
            </div>
          ) : null}
        </div>

        <div
          style={{
            padding: '12px 18px',
            borderTop: '1px solid #e2e8f0',
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 8,
            background: '#fff',
          }}
        >
          <button
            type="button"
            onClick={onClose}
            disabled={busy}
            style={{
              border: '1px solid #cbd5e1',
              background: '#fff',
              color: '#475569',
              fontWeight: 800,
              fontSize: 13,
              padding: '10px 16px',
              borderRadius: 8,
              cursor: busy ? 'not-allowed' : 'pointer',
            }}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={busy}
            style={{
              border: 'none',
              background: busy
                ? '#94a3b8'
                : `linear-gradient(135deg, ${WA_DARK}, ${WA})`,
              color: '#fff',
              fontWeight: 800,
              fontSize: 13,
              padding: '10px 18px',
              borderRadius: 8,
              cursor: busy ? 'not-allowed' : 'pointer',
              boxShadow: busy ? 'none' : '0 3px 10px rgba(37, 211, 102, 0.22)',
              opacity: busy ? 0.85 : 1,
            }}
          >
            {busy ? 'Sending…' : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  )
}

// Created By Cursor
function InfoChip({ icon, label }) {
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        fontSize: 12,
        fontWeight: 700,
        color: '#0f172a',
        background: '#f8fafc',
        border: '1px solid #e2e8f0',
        borderRadius: 999,
        padding: '6px 10px',
      }}
    >
      <i className={`fa ${icon}`} style={{ color: WA_DARK }} aria-hidden />
      {label}
    </span>
  )
}
